import getEnvironment from "./getEnvironment";

export default (): boolean => {
    const environment = getEnvironment();
    return environment === "development" || typeof(environment) === "undefined";
};